import React from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FilterHeader from "views/lib/components/filter/filter-header";
import { Link } from "react-router-dom";

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };
  }

  render() {
    const {
      isOpen
    } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title={
            <div>
              Statiic Pages

              <Link to="/static-pages/create" className="btn btn-sm mx-2 btn-warning" title="Create new page">
                <FontAwesomeIcon icon={faPlus}/>
              </Link>
            </div>
          }
          totalCount={false}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
          noExpand={true}
        />
      </Card>
    );
  }
}

Filters.propTypes = {
  handleCreate: PropTypes.func.isRequired,
};
export default Filters;



// WEBPACK FOOTER //
// ./src/views/pages/static-pages/filters.js